module.exports = __webpack_public_path__ + "static/media/prime.5ada25be.png";